"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemButtons = exports.rootStyleMobile = exports.rootStyleDesktop = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var rootStyleDesktop =
/*#__PURE__*/
(0, _emotion.css)("position:relative;");
exports.rootStyleDesktop = rootStyleDesktop;
var rootStyleMobile =
/*#__PURE__*/
(0, _emotion.css)("position:relative;font-size:14px;letter-spacing:0.1px;line-height:1.31;text-align:left;color:inherit;margin:14px 0px;");
exports.rootStyleMobile = rootStyleMobile;
var itemButtons =
/*#__PURE__*/
(0, _emotion.css)("background-color:", _themeConfig.default.color.dark.earth, ";margin-right:8px;margin-bottom:8px;text-transform:unset;cursor:pointer;:focus{outline:none;}&.selected{background-color:", _themeConfig.default.color.dark.sapphire, ";}");
exports.itemButtons = itemButtons;